import { DictionaryObject, abortableFetch, useFetch } from '@eas/common-web';
import { Loan } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useLoanStates() {
  return useFetch<DictionaryObject[]>(`${EvidenceApiUrl.LOAN}/state/list`, {
    method: 'GET',
  });
}

export function createLoan(
  loan: Pick<Loan, 'loanedFile' | 'borrower' | 'relatedFile'>
) {
  return abortableFetch(EvidenceApiUrl.LOAN, {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(loan),
  });
}

export function returnLoan(id: string) {
  return abortableFetch(`${EvidenceApiUrl.LOAN}/${id}/return`, {
    method: 'PUT',
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });
}

export function cancelLoan(id: string) {
  return abortableFetch(`${EvidenceApiUrl.LOAN}/${id}/cancel`, {
    method: 'PUT',
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });
}
